namespace Matrix.Data {
    export interface SecurityOverrideRow {
        SecurityId?: number;
        SecurityCode?: string;
        DealParentCode?: string;
        Name?: string;
        SecurityTypeCode?: string;
        LocalCurrencyCode?: string;
        ExposureMultiplier?: number;
        AssociatedAccountCode?: string;
        Sedol?: string;
        RIC?: string;
        Isin?: string;
        Cusip?: string;
        Figi?: string;
        Ticker?: string;
        InternalSecurityCode?: string;
        Issuer?: string;
        IssuerCode?: string;
        BorrowerCode?: string;
        CouponRate?: number;
        MaturityDate?: string;
        SpLtRating?: string;
        SpStRating?: string;
        MoodysLtRating?: string;
        MoodysStRating?: string;
        FitchLtRating?: string;
        FitchStRating?: string;
        InternalLtRating?: string;
        InternalStRating?: string;
        CountryOfIssueCode?: string;
        CountryOfRiskCode?: string;
        CurrencyOfRiskCode?: string;
        TradeDate?: string;
        EffectiveDate?: string;
        BrokerCode?: string;
        Strategy?: string;
        OptionStyle?: string;
        ExerciseStyle?: string;
        PutOrCall?: string;
        StrikePrice?: number;
        StrikeCurrency?: string;
        Premium?: number;
        PremiumCcy?: string;
        PayOrRec?: string;
        FixedOrFloat?: string;
        FloatIndex?: string;
        InflationIndexLag?: string;
        InterestTerm?: string;
        Spread?: number;
        AllIn?: number;
        InterestCcy?: string;
        PaymentFrequency?: string;
        PaymentBusDayConvention?: string;
        PaymentCalendar?: string;
        FirstPaymentDate?: string;
        DayCountBasis?: string;
        ResetFrequency?: string;
        ResetBusDayConvention?: string;
        ResetCalendar?: string;
        ClearerReference?: string;
        RedCode?: string;
        CreditEvents?: string;
        Guarantor?: string;
        GicsSector?: number;
        GicsIndustryGroup?: number;
        GicsIndustry?: number;
        GicsSubIndustry?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
        OverrideNull?: SecurityOverrideNullRow;
    }

    export namespace SecurityOverrideRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'DealParentCode';
        export const localTextPrefix = 'Data.SecurityOverride';
        export const deletePermission = 'DataAdmin:SecurityOverride';
        export const insertPermission = 'DataAdmin:SecurityOverride';
        export const readPermission = 'Read:SecurityOverride';
        export const updatePermission = 'DataAdmin:SecurityOverride';

        export declare const enum Fields {
            SecurityId = "SecurityId",
            SecurityCode = "SecurityCode",
            DealParentCode = "DealParentCode",
            Name = "Name",
            SecurityTypeCode = "SecurityTypeCode",
            LocalCurrencyCode = "LocalCurrencyCode",
            ExposureMultiplier = "ExposureMultiplier",
            AssociatedAccountCode = "AssociatedAccountCode",
            Sedol = "Sedol",
            RIC = "RIC",
            Isin = "Isin",
            Cusip = "Cusip",
            Figi = "Figi",
            Ticker = "Ticker",
            InternalSecurityCode = "InternalSecurityCode",
            Issuer = "Issuer",
            IssuerCode = "IssuerCode",
            BorrowerCode = "BorrowerCode",
            CouponRate = "CouponRate",
            MaturityDate = "MaturityDate",
            SpLtRating = "SpLtRating",
            SpStRating = "SpStRating",
            MoodysLtRating = "MoodysLtRating",
            MoodysStRating = "MoodysStRating",
            FitchLtRating = "FitchLtRating",
            FitchStRating = "FitchStRating",
            InternalLtRating = "InternalLtRating",
            InternalStRating = "InternalStRating",
            CountryOfIssueCode = "CountryOfIssueCode",
            CountryOfRiskCode = "CountryOfRiskCode",
            CurrencyOfRiskCode = "CurrencyOfRiskCode",
            TradeDate = "TradeDate",
            EffectiveDate = "EffectiveDate",
            BrokerCode = "BrokerCode",
            Strategy = "Strategy",
            OptionStyle = "OptionStyle",
            ExerciseStyle = "ExerciseStyle",
            PutOrCall = "PutOrCall",
            StrikePrice = "StrikePrice",
            StrikeCurrency = "StrikeCurrency",
            Premium = "Premium",
            PremiumCcy = "PremiumCcy",
            PayOrRec = "PayOrRec",
            FixedOrFloat = "FixedOrFloat",
            FloatIndex = "FloatIndex",
            InflationIndexLag = "InflationIndexLag",
            InterestTerm = "InterestTerm",
            Spread = "Spread",
            AllIn = "AllIn",
            InterestCcy = "InterestCcy",
            PaymentFrequency = "PaymentFrequency",
            PaymentBusDayConvention = "PaymentBusDayConvention",
            PaymentCalendar = "PaymentCalendar",
            FirstPaymentDate = "FirstPaymentDate",
            DayCountBasis = "DayCountBasis",
            ResetFrequency = "ResetFrequency",
            ResetBusDayConvention = "ResetBusDayConvention",
            ResetCalendar = "ResetCalendar",
            ClearerReference = "ClearerReference",
            RedCode = "RedCode",
            CreditEvents = "CreditEvents",
            Guarantor = "Guarantor",
            GicsSector = "GicsSector",
            GicsIndustryGroup = "GicsIndustryGroup",
            GicsIndustry = "GicsIndustry",
            GicsSubIndustry = "GicsSubIndustry",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen",
            OverrideNull = "OverrideNull"
        }
    }
}
